import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 财务管理
 */
export default {
  path: 'financial',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '财务管理',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [
    workbenchServiceDict.PURCHASER.value,
    workbenchServiceDict.AGENCY.value
  ],
  roles: [
    platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 收入账单
    {
      path: 'revenue',
      name: 'FinancialRevenue',
      component: '/financial-views/revenue',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '收入账单',
        icon: 'icon-side_financial_revenue'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 发票管理
    {
      path: 'invoice',
      name: 'FinancialInvoice',
      component: '/financial-views/invoice',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '发票管理',
        icon: 'icon-side_financial_invoice'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 账户管理
    {
      path: 'account',
      name: 'FinancialAccount',
      component: '/financial-views/account',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '账户管理',
        icon: 'icon-side_financial_account'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 保证金对账查询
    {
      path: 'guarantee-reconciliation',
      name: 'GuaranteeReconciliation',
      component: '/financial-views/guarantee-reconciliation',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '保证金对账查询',
        icon: 'icon-side-baozhengjinduizhangchaxun'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 收入管理
    {
      path: 'revenue-manage',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '收入管理',
        icon: 'icon-side-shouruguanli',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 收入列表
        {
          path: 'list',
          name: 'RevenueManagementList',
          component: '/financial-views/revenue-management/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '收入列表',
            cache: true,
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 添加实际收入
        {
          path: ':id/actual-income-fill',
          name: 'ActualIncomeFill',
          component: '/financial-views/revenue-management/actual-income-fill',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '添加实际收入',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 实际收入详情
        {
          path: ':id/detail',
          name: 'RevenueManagementDetail',
          component: '/financial-views/revenue-management/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '实际收入详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.FINANCIAL_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
